import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M109.44 54.85a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="m16.18 25.53 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94L8 29.47a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94L18 31.59c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path fill="#0597A3" d="M31.21 14.63a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M108.57 24.03H103v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H100v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M67.85 109.4c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M59.01 91H35.09C32.28 91 30 88.73 30 85.92V30.08c0-2.8 2.28-5.08 5.09-5.08h36.07c1.35 0 2.64.53 3.6 1.49l9.75 9.72c.95.95 1.49 2.24 1.49 3.59v44.04c0 3.96-3.22 7.17-7.19 7.17h-19.8z"
    />
    <path
      fill="#001A43"
      d="M73 39.25H41c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h32c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M69 53.25H41c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h28c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M63 67.25H41c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h22c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M59 81.25H41c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#0597A3"
      d="M88 96c10.49 0 19-8.51 19-19s-8.51-19-19-19-19 8.51-19 19 8.51 19 19 19"
    />
    <path
      fill="#001A43"
      d="M98 79.25H88c-1.24 0-2.25-1.01-2.25-2.25V67c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v7.75H98c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconTimesheetsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconTimesheetsInverted);
export default Memo;
